import ReactHtmlParser from 'react-html-parser';
import DOMPurify from 'isomorphic-dompurify';

const ParsedContent = ({ children }) => children && ReactHtmlParser(DOMPurify.sanitize(children));

export default ParsedContent;



// WEBPACK FOOTER //
// ./src/components/elements/ParsedContent/index.js